import _isEqual from 'lodash/isEqual';

export function clearDefaultValues(targetObj, defaultValues) {
  const keys = Object.keys({ ...targetObj, ...defaultValues });
  const clearedValues = keys.reduce((acc, key) => {
    const targetValue = targetObj[key];
    const defaultValue = defaultValues[key];
    if (!_isEqual(targetValue, defaultValue)) {
      if (targetValue && typeof targetValue === 'object' && !Array.isArray(targetValue)) {
        // deep clearing
        acc[key] = clearDefaultValues(targetValue, defaultValue);
      } else {
        acc[key] = targetValue;
      }
    }
    return acc;
  }, {});

  return Object.keys(clearedValues).length ? clearedValues : undefined;
}
